export const EMBEDDED_NOTEPAD_ACCESS_DENIED_MESSAGE =
  'Only available for users with Notepad access.';
